import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { ImageCreative } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/AdCreative';
// import { ImageCreative, ImageCrops } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/AdCreative';
import { computed } from 'vue';

// Duplicated types because vue < 3.3 doesn't support declaring Props with an imported type

interface Props extends ImageCreative {
  image_hash?: string;
  image_url: string;
  width?: number;
  height?: number;
  size?: number;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcMediaImage.ts',
  props: {
    image_hash: null,
    image_url: null,
    width: null,
    height: null,
    size: null,
    disabled: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  image_hash?: string;
  image_url: string;
  width?: number;
  height?: number;
  size?: number;
  disabled?: boolean;
};



const imageSize = computed(() => {
  if (!props.size) return '';

  if (props.size < 1024) {
    return `${props.size.toFixed(1)} B`;
  }
  if (props.size < 1048576) {
    return `${(props.size / 1024).toFixed(1)} KB`;
  }
  return `${(props.size / 1048576).toFixed(1)} MB`;
});



function onImageChange() {
  emits('change');
}

return { __sfc: true,props, imageSize, emits, onImageChange, CcIcon }
}

})